import { Component, Inject } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";
import { AuthService } from "src/app/core/core-services/services/auth.service";

/** Payload for {@link ProfileUpdatedSuccessfullyComponent}. */
export interface ProfileUpdateConfirmData {
  /** The just-submitted form value; names may arrive in snake or camel case. */
  formValue: {
    first_name?: string;
    last_name?: string;
    firstName?: string;
    lastName?: string;
  };
}

/**
 * Two-phase "Update Profile Name?" dialog: first asks the user to keep or
 * update their profile name (comparing the current name against
 * `data.formValue`), then shows a success screen.
 *
 * Closes with `true` when the user chose Update, `false` when they chose
 * Keep — the opener decides what happens next in `afterClosed()`.
 */
@Component({
  selector: "profile-updated-successfully",
  templateUrl: "./profile-updated-successfully.component.html",
  styleUrls: ["./profile-updated-successfully.component.scss"],
  standalone: false,
})
export class ProfileUpdatedSuccessfullyComponent {
  confirmed = false;
  formValue: ProfileUpdateConfirmData["formValue"];
  user: any;

  constructor(
    private readonly authService: AuthService,
    @Inject(VNG_DIALOG_DATA) public data: ProfileUpdateConfirmData,
    public dialogRef: VngDialogRef<ProfileUpdatedSuccessfullyComponent, boolean>
  ) {
    this.formValue = data.formValue;
    this.user = this.authService.userDetails;
  }

  update(): void {
    this.confirmed = true;
  }

  close(): void {
    this.dialogRef.close(this.confirmed);
  }
}
